import React from 'react';
import PropTypes from 'prop-types';
import S from 'calendar.scss';

const CalendarLegendCell = ({ children }) => <div className={S.legendCell}>{children}</div>;

CalendarLegendCell.propTypes = {
  children: PropTypes.node,
};

export default CalendarLegendCell;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarLegendCell.jsx